import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'

export class DeleteTemporaryRmaLineUpload extends RmaRequest<void, never> {
  path: string
  override init: RequestInit = { method: 'DELETE' }

  constructor({ identifier }: { identifier: string }) {
    super()
    this.path = `account/rma/draft/upload/temporary/${identifier}/`
  }

  override parseResponse = (data: unknown) => data as string
}
